// CheckInService — migrated to the OpenAPI-generated client.
//
// Each function keeps its exact pre-migration return shape: the getters returned the raw
// axios `response`, so callers read `res.data` (the parsed HttpResponse body). We reproduce
// that by returning `{data}` where `data` is the parsed JSON body the SDK gives back. The
// auth/timezone headers now come from configureApi's interceptor, so the per-call
// localStorage token reads are gone.
//
// Error contract preserved: callers `.catch(e => e.response?.data?.errorCode)`. The generated
// client returns `{error, response}` (error = parsed server body) on non-2xx, so we re-throw
// an axios-shaped `{response: {data: error, status}}` to keep that exact shape.
//
// NOTE: the server DTOs for getCheckIns/getStats/getPendingCount no longer accept a
// `companyId` query param (removed in the IDOR/company-scoping sweep — scope comes from the
// principal). We keep the `companyId` parameter in each signature so callers are unchanged,
// but no longer send it.
import {
    adminCheckInControllerGetCheckIns,
    adminCheckInControllerGetTraineeCheckIns,
    adminCheckInControllerGetById,
    adminCheckInControllerCreate,
    adminCheckInControllerDelete,
    adminCheckInControllerGetStats,
    adminCheckInControllerGetPendingCount,
    adminCheckInControllerMarkReviewed,
} from '../api/generated';

// Re-throw the generated client's {error, response} as the axios-shaped error callers expect
// (so `e.response?.data?.errorCode` keeps working post-migration).
const throwAsAxiosError = (error, response) => {
    throw {response: {data: error, status: response?.status}};
};

export const getCheckIns = async (pageId = 0, pageSize = 20, status = null, companyId = null, keyword = null) => {
    const {data, error, response} = await adminCheckInControllerGetCheckIns({
        query: {
            pageId,
            pageSize,
            ...(status ? {status} : {}),
            ...(keyword ? {keyword} : {}),
        },
    });
    if (error) throwAsAxiosError(error, response);
    return {data};
};

export const getTraineeCheckIns = async (traineeId) => {
    const {data, error, response} = await adminCheckInControllerGetTraineeCheckIns({
        path: {traineeId},
    });
    if (error) throwAsAxiosError(error, response);
    return {data};
};

export const getCheckInById = async (checkInId) => {
    const {data, error, response} = await adminCheckInControllerGetById({
        path: {checkInId},
    });
    if (error) throwAsAxiosError(error, response);
    return {data};
};

export const createCheckIn = async (data) => {
    const {data: resData, error, response} = await adminCheckInControllerCreate({
        body: data,
    });
    if (error) throwAsAxiosError(error, response);
    return {data: resData};
};

export const deleteCheckIn = async (checkInId) => {
    const {data, error, response} = await adminCheckInControllerDelete({
        path: {checkInId},
    });
    if (error) throwAsAxiosError(error, response);
    return {data};
};

export const getCheckInStats = async (companyId = null) => {
    const {data, error, response} = await adminCheckInControllerGetStats({});
    if (error) throwAsAxiosError(error, response);
    return {data};
};

export const getPendingCheckInCount = async (companyId = null) => {
    const {data, error, response} = await adminCheckInControllerGetPendingCount({});
    if (error) throwAsAxiosError(error, response);
    return {data};
};

export const markCheckInReviewed = async (checkInId) => {
    const {data, error, response} = await adminCheckInControllerMarkReviewed({
        path: {checkInId},
    });
    if (error) throwAsAxiosError(error, response);
    return {data};
};
